import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X, Maximize2 } from "lucide-react";
import { mediaUrl, youtubeEmbed } from "../../lib/api";

export const Lightbox = ({ items, index, onClose, onIndex }) => {
  useEffect(() => {
    if (index === null) return;
    const on = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", on);
    return () => window.removeEventListener("keydown", on);
  }, [index, items, onClose, onIndex]);
  if (index === null || !items?.[index]) return null;
  const it = items[index];
  const yt = it.media_type === "video" && youtubeEmbed(it.url);
  return (
    <div className="fixed inset-0 z-[100] bg-[#050d1f]/95 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in" onClick={onClose} data-testid="lightbox">
      <button className="absolute top-5 right-5 text-white/80 hover:text-white p-2" onClick={onClose} data-testid="lightbox-close"><X className="h-7 w-7" /></button>
      <button className="absolute top-5 right-20 text-white/80 hover:text-white p-2" onClick={(e) => { e.stopPropagation(); document.fullscreenElement ? document.exitFullscreen() : e.currentTarget.parentElement.requestFullscreen?.(); }} data-testid="lightbox-fullscreen" aria-label="Full screen"><Maximize2 className="h-6 w-6" /></button>
      <span className="absolute top-7 left-6 text-sm text-white/70" data-testid="lightbox-counter">{index + 1} / {items.length}</span>
      {items.length > 1 && (
        <>
          <button className="absolute left-3 md:left-8 text-white/80 hover:text-white p-3 rounded-full bg-white/10" onClick={(e) => { e.stopPropagation(); onIndex((index - 1 + items.length) % items.length); }} data-testid="lightbox-prev"><ChevronLeft className="h-6 w-6" /></button>
          <button className="absolute right-3 md:right-8 text-white/80 hover:text-white p-3 rounded-full bg-white/10" onClick={(e) => { e.stopPropagation(); onIndex((index + 1) % items.length); }} data-testid="lightbox-next"><ChevronRight className="h-6 w-6" /></button>
        </>
      )}
      <figure className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
        {it.media_type === "video" ? (
          yt ? <iframe title={it.title} src={yt} className="w-full aspect-video rounded-xl" allowFullScreen /> : <video src={mediaUrl(it.url)} controls className="w-full max-h-[80vh] rounded-xl" />
        ) : (
          <img src={mediaUrl(it.url)} alt={it.title} className="mx-auto max-h-[80vh] rounded-xl object-contain" data-testid="lightbox-image" />
        )}
        {it.title && <figcaption className="mt-4 text-center text-sm text-slate-300" data-testid="lightbox-caption">{it.title}</figcaption>}
      </figure>
    </div>
  );
};
